export enum Roles {
  Guest = 0,
  User = 1,
  Agent = 2,
  Admin = 9,
}

const AllUsers: number[] = Object.keys(Roles)
  .map((key: any) => Number.parseInt(Roles[key]))
  .filter((k) => k >= 0);

const RegisteredUsers: number[] = Object.keys(Roles)
  .map((key: any) => Number.parseInt(Roles[key]))
  .filter((k) => k > 0);

export default {
  ...Roles,
  All: AllUsers,
  Registered: RegisteredUsers,
};
